import React, { useMemo, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";

function buildBasicHeader(clientId, accessKey) {
  return `Basic ${btoa(`${clientId}:${accessKey}`)}`;
}

export default function AccessTokenRotateModal({ open, token, onClose, onRotate }) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [rotated, setRotated] = useState(null);

  const basicHeader = useMemo(() => {
    if (!rotated?.client_id || !rotated?.access_key) return "";
    return buildBasicHeader(rotated.client_id, rotated.access_key);
  }, [rotated]);

  const handleRotate = async () => {
    if (!token?.pat_id) return;
    setSubmitting(true);
    setError(null);
    try {
      const result = await onRotate(token.pat_id);
      setRotated(result);
    } catch (err) {
      setError(err.message || "Error al rotar token");
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setError(null);
    setRotated(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{rotated ? "Access Key rotada" : "Rotar token"}</DialogTitle>
      <DialogContent>
        {rotated ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Alert severity="warning">{rotated.warning}</Alert>
            <TextField
              label="Nueva Access Key"
              fullWidth
              value={rotated.access_key}
              InputProps={{ readOnly: true, sx: { fontFamily: "monospace" } }}
            />
            <Box>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Authorization para POST /auth
              </Typography>
              <TextField
                fullWidth
                multiline
                minRows={2}
                value={basicHeader}
                InputProps={{ readOnly: true, sx: { fontFamily: "monospace", fontSize: 12 } }}
              />
            </Box>
          </Box>
        ) : (
          <Box sx={{ pt: 1 }}>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
            <Alert severity="warning" sx={{ mb: 2 }}>
              La Access Key anterior deja de funcionar de inmediato. Actualizá el sistema conectado
              antes de rotar, no después.
            </Alert>
            <Typography>
              ¿Rotar credenciales de <strong>{token?.label}</strong> ({token?.client_id})?
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        {rotated ? (
          <>
            <Button onClick={() => navigator.clipboard.writeText(basicHeader)}>Copiar Basic</Button>
            <Button variant="contained" onClick={handleClose}>
              Cerrar
            </Button>
          </>
        ) : (
          <>
            <Button onClick={handleClose}>Cancelar</Button>
            <Button variant="contained" color="warning" onClick={handleRotate} disabled={submitting}>
              Rotar ahora
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
